import { clearDocumentSubscriptionCache } from './documentAccess';
import { clearSubscriptionCache } from './featureLock';

/** Clear Flowdo client-side session (tokens, user, caches). */
export function clearFlowdoClientSession() {
  try {
    clearDocumentSubscriptionCache();
    clearSubscriptionCache();
  } catch (err) {
    console.error('Error clearing subscription caches:', err);
  }

  localStorage.removeItem('accessToken');
  localStorage.removeItem('tempAccessToken');
  localStorage.removeItem('user');
  localStorage.removeItem('userDetails');
  localStorage.removeItem('rememberMe');
  localStorage.removeItem('userPlanFeatures');
  sessionStorage.removeItem('accessToken');
  sessionStorage.removeItem('tabCount');
  sessionStorage.removeItem('isFirstSession');
  sessionStorage.removeItem('redirectAfterLogin');
  localStorage.setItem('logout', Date.now());
}

/** Call Flowdo logout API and clear client session. */
export async function performFlowdoLogout(axiosInstance) {
  try {
    await axiosInstance.post('/auth/user/logout');
  } catch (err) {
    console.error('Error clearing refresh token:', err);
  }
  clearFlowdoClientSession();
}
